import { FirebaseAuth } from '../../../../lib/firebase'
import { isDesktopApp } from './helpers'
import { twitterProvider } from './providers'

export const twitterSignIn = (): Promise<any> => {
  return isDesktopApp
    ? FirebaseAuth.signInWithRedirect(twitterProvider)
    : FirebaseAuth.signInWithPopup(twitterProvider)
}
